(function () {
  function initGallery(gallery) {
    if (!gallery || gallery.dataset.galleryReady === 'true') return;

    const mainImage = gallery.querySelector('[data-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const prevButtons = Array.from(gallery.querySelectorAll('[data-gallery-prev]'));
    const nextButtons = Array.from(gallery.querySelectorAll('[data-gallery-next]'));

    if (!mainImage || thumbs.length === 0) return;

    gallery.dataset.galleryReady = 'true';
    let currentIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    function updateNavState() {
      const disabled = thumbs.length <= 1;
      prevButtons.forEach((button) => { button.disabled = disabled; });
      nextButtons.forEach((button) => { button.disabled = disabled; });
    }

    function showImage(index, shouldScroll) {
      const total = thumbs.length;
      if (!total) return;

      currentIndex = (index + total) % total;
      const thumb = thumbs[currentIndex];
      const fullSrc = thumb.dataset.galleryFull;
      const alt = thumb.dataset.galleryAlt || '';

      thumbs.forEach((item, itemIndex) => {
        const active = itemIndex === currentIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (fullSrc && mainImage.getAttribute('src') !== fullSrc) {
        mainImage.classList.add('is-changing');
        window.setTimeout(() => {
          mainImage.removeAttribute('srcset');
          mainImage.src = fullSrc;
          mainImage.alt = alt;
          mainImage.classList.remove('is-changing');
        }, 80);
      } else {
        mainImage.alt = alt;
      }

      if (shouldScroll) {
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showImage(index, true));
      thumb.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showImage(currentIndex - 1, true);
          thumbs[currentIndex].focus();
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showImage(currentIndex + 1, true);
          thumbs[currentIndex].focus();
        }
      });
    });

    prevButtons.forEach((button) => button.addEventListener('click', () => showImage(currentIndex - 1, true)));
    nextButtons.forEach((button) => button.addEventListener('click', () => showImage(currentIndex + 1, true)));

    updateNavState();
    showImage(currentIndex, false);
  }

  function initAllGalleries(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-japotyle-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllGalleries());
  } else {
    initAllGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => initAllGalleries(event.target));
})();
